import type { Profile } from '../types';

// Champs de PersonalInfoScreen requis pour un profil « complet » (adresse exclue : facultative).
// Source UNIQUE de vérité de la complétude, alimente le pop-up de relance. On lit le profil
// PERSISTÉ (ce sont ces données qui alimentent les CV générés), pas l'email de connexion.
export const PERSONAL_INFO_REQUIRED_FIELDS = [
  'first_name',
  'last_name',
  'email',
  'phone',
  'linkedin_url',
] as const;

export function isPersonalInfoComplete(profile: Profile | null): boolean {
  if (!profile) return false;
  return PERSONAL_INFO_REQUIRED_FIELDS.every((key) => {
    const value = profile[key];
    return typeof value === 'string' && value.trim().length > 0;
  });
}
